import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Sigil } from './Identity';
import { navigation } from '../data/series';
import { SiteAnchor } from './SiteAnchor';

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
    setActive(pathname.startsWith('/bestiary') ? 'bestiary' : pathname.startsWith('/journal') ? 'journal' : '');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) setActive(entry.target.id); });
    }, { rootMargin: '-15% 0px -50% 0px' });
    document.querySelectorAll('main > section[id]').forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, [pathname]);
  useEffect(() => {
    const close = event => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);
  return <header className="site-header" data-testid="site-header">
    <SiteAnchor section="home" className="brand" data-testid="brand-home-link" onClick={() => setOpen(false)} aria-label="The Aetherios, back to the beginning">
      <Sigil className="brand-sigil" /><span className="brand-name">THE AETHERIOS<span>A COLLECTION OF FOUR STORIES</span></span>
    </SiteAnchor>
    <nav className={`main-nav ${open ? 'is-open' : ''}`} id="main-navigation" aria-label="Main navigation" data-testid="main-navigation">
      {navigation.map(item => {
        const props = { 'data-testid': `nav-${item.id}`, className: active === item.id ? 'active' : '', 'aria-current': active === item.id ? 'location' : undefined, onClick: () => setOpen(false) };
        return item.href ? <Link key={item.id} to={item.href} {...props}><span>{item.number}</span>{item.label}</Link> : <SiteAnchor key={item.id} section={item.id} {...props}><span>{item.number}</span>{item.label}</SiteAnchor>;
      })}
    </nav>
    <SiteAnchor section="world" className="header-cta" data-testid="header-explore-link">Enter the atlas <ArrowUpRight size={15} /></SiteAnchor>
    <Button variant="ghost" size="icon" className="mobile-toggle" data-testid="mobile-menu-toggle" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</Button>
  </header>;
};